export default function Button({ text, className = "", style = {} }) {
  return (
    <button className={className} style={style}>
      {text}
    </button>
  );
}
